<template>
  <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6">
    <div
      v-for="(stat, index) in stats"
      :key="index"
      class="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200"
    >
      <div
        class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-space-y-0 tw-pb-2 tw-p-6"
      >
        <h3 class="tw-text-sm tw-font-medium tw-text-gray-600">
          {{ stat.title }}
        </h3>
        <div :class="`tw-p-2 tw-rounded-lg ${stat.bgColor}`">
          <component :is="stat.icon" :class="`tw-w-4 tw-h-4 ${stat.color}`" />
        </div>
      </div>
      <div class="tw-px-6 tw-pb-6">
        <div class="tw-text-2xl tw-font-bold tw-text-gray-900">
          {{ stat.value.toLocaleString() }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ShoppingCart, FolderOpen, Users } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

interface Props {
  orders: number;
  projects: number;
  teamMembers: number;
}

const props = defineProps<Props>();
const { t } = useI18n();

const stats = computed(() => [
  {
    title: t('customer_management.titles.orders'),
    value: props.orders,
    icon: ShoppingCart,
    color: 'tw-text-blue-600',
    bgColor: 'tw-bg-blue-50',
  },
  {
    title: t('projects.common.projects_title'),
    value: props.projects,
    icon: FolderOpen,
    color: 'tw-text-emerald-600',
    bgColor: 'tw-bg-emerald-50',
  },
  {
    title: t('customer_management.titles.team_members'),
    value: props.teamMembers,
    icon: Users,
    color: 'tw-text-purple-600',
    bgColor: 'tw-bg-purple-50',
  },
]);
</script>
